import { FeatureInfo } from './featureinfo';

export class LayersInfo {
    layersFeatures=new Array<FeatureInfo>();
    message:String;
}
